import { i18n } from "../../../boot/i18n";

import account from "./account";
import company from "./company";
import expense from "./expense";
import payroll from "./payroll";
import mileageRates from "./mileage-rates";

const children = [
  ...account.routes,
  ...company.routes,
  ...expense.routes,
  ...payroll.routes,
  ...mileageRates.routes,
];

export default {
  routes: [
    {
      name: "accounting",
      path: "accounting",
      component: () => import("pages/accounting/Index"),
      meta: {
        auth: () =>
          children.some((route) => route.meta.auth && route.meta.auth()),
        icon: "accounting",
        title: i18n.global.t("Accounting"),
        color: "primary",
      },
      children,
    },
  ],

  dialogs: [
    ...account.dialogs,
    ...company.dialogs,
    ...expense.dialogs,
    ...payroll.dialogs,
    ...mileageRates.dialogs,
  ],
};
